import defu from 'defu'

type CurrencyOptions = {
  locale?: string
} & Intl.NumberFormatOptions

export default function (
  value: number | string,
  options: CurrencyOptions = {},
) {
  value = Number(value)

  const { currency } = useAppConfig()
  const { $i18n } = useNuxtApp()

  const i18nLocale = $i18n.locales.value.find(
    locale => locale.code === $i18n.locale.value,
  )

  const defaultSettings = {
    currency: 'EUR',
    locale: i18nLocale?.language || 'fr-FR',
    maximumFractionDigits: currency.maximumFractionDigits,
  }

  if (Number.isNaN(value)) {
    return undefined
  }

  const mergedOptions = defu(options, defaultSettings)

  return Intl.NumberFormat(mergedOptions.locale, {
    style: 'currency',
    ...mergedOptions,
  })
    .format(value)
    .replaceAll('\u00A0', ' ')
    .replaceAll('\u202F', ' ')
}
